import {
  base_colorAction,
  base_colorContentBorder,
  base_colorContentBorderSecondary,
  base_colorRaisedSurface,
  base_colorSurfaceSecondary,
  text_colorTextBranded,
  text_colorTextPrimary,
  text_colorTextSecondary,
  text_colorTextSuccess,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const receiptRecoveryHeaderStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ReceiptRecoverySection--header-label {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
  }
`

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(4)};

  .ReceiptRecoverySection--agent-context,
  .ReceiptRecoverySection--reconciled {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    padding: ${spacing(4)};
    border: 1px solid ${base_colorContentBorderSecondary};
    border-radius: ${cornerRadius};
  }

  .ReceiptRecoverySection--agent-context {
    background: ${base_colorSurfaceSecondary};
  }

  .ReceiptRecoverySection--agent-label {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
    color: ${text_colorTextBranded};
    font-family: ${font_family_weight_medium};
    ${font_sm}
  }

  .ReceiptRecoverySection--description,
  .ReceiptRecoverySection--provenance,
  .ReceiptRecoverySection--confirmation {
    margin: 0;
    font-family: ${font_family_weight_regular};
    ${font_sm}
    color: ${text_colorTextSecondary};
  }

  .ReceiptRecoverySection--receipt {
    display: flex;
    align-items: center;
    gap: ${spacing(3)};
    padding: ${spacing(3)};
    background: ${base_colorRaisedSurface};
    border: 1px solid ${base_colorContentBorder};
    border-radius: ${cornerRadius};

    .ReceiptRecoverySection--receipt-name {
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_medium};
      ${font_md}
    }
  }

  .ReceiptRecoverySection--review {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
  }

  .ReceiptRecoverySection--submit {
    align-self: flex-start;
  }

  .ReceiptRecoverySection--reconciled {
    background: ${base_colorSurfaceSecondary};
    border-color: ${text_colorTextSuccess};
  }

  .ReceiptRecoverySection--reconciled-heading {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
    color: ${text_colorTextSuccess};
    font-family: ${font_family_weight_medium};
    ${font_md}
  }

  .ReceiptRecoverySection--receipt-icon {
    flex: none;
    color: ${base_colorAction};
  }
`
